// src/constants/colors.js
export const COLORS = {
  primary: 'var(--color-accent)', // dynamic accent color
  primaryLight: 'var(--color-accent-hover)',
  textGray: 'var(--color-text-secondary)',
  lightBackground: 'var(--color-surface-muted)',
  brandBlue: '#000000',
  // …you can put more (secondary, accent, etc.)
};
